module.exports = __webpack_public_path__ + "img/about-us-1.5018dd4e.jpg";